import React from "react";
import { useTranslation } from "react-i18next";
import { RoomMovie } from "../../../api/room";
import { movieTitleHandler } from "../../../utils/helpers";
import styles from "./RoomMovieCard.module.scss";

const IMG_BASE = process.env.REACT_APP_IMG_BASE_URL;

interface RoomMovieCardProps {
  movie: RoomMovie;
  onClick?: () => void;
}

const getPosterPath = (lng: string, movie: RoomMovie): string => {
  if (lng === "ru" && movie.poster_path_ru) return movie.poster_path_ru;
  if (lng === "uk" && movie.poster_path_ua) return movie.poster_path_ua;
  if (lng === "ar" && movie.poster_path_ar) return movie.poster_path_ar;
  return movie.poster_path;
};

const RoomMovieCard: React.FC<RoomMovieCardProps> = ({ movie, onClick }) => {
  const { i18n } = useTranslation();
  const title = movieTitleHandler(i18n.language, movie) || movie.title;
  const poster = getPosterPath(i18n.language, movie);
  const year = movie.release_date?.slice(0, 4);
  const rating = movie.imdb_rating?.toFixed(1) || movie.vote_average?.toFixed(1);
  const genreList = movie.genres?.split(",").map((g) => g.trim()).slice(0, 2);

  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.posterWrap}>
        {poster ? (
          <img src={`${IMG_BASE}${poster}`} alt={title} className={styles.poster} />
        ) : (
          <div className={styles.posterPlaceholder}>{title}</div>
        )}
      </div>
      <div className={styles.info}>
        <div className={styles.title}>{title}</div>
        <div className={styles.meta}>
          {year && <span className={styles.year}>{year}</span>}
          {movie.production_companies && (
            <span className={styles.country}>
              {movie.production_companies.split(",")[0]?.trim()}
            </span>
          )}
        </div>
        {genreList && genreList.length > 0 && (
          <div className={styles.genres}>{genreList.join(" ")}</div>
        )}
        {rating && (
          <div className={styles.rating}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#f5c518">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
            <span>{rating}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoomMovieCard;
